export default __webpack_public_path__ + "static/media/oxygen.34d92e3c.svg";